export default {"src":"/_next/static/media/mock_star_filled.e9db94db.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};